import { request } from 'data/requests/request';

const productRequest = (location: string, manufacturer: string, model?: string, type?: string) =>
    request({
        type: 'matProductResponse',
        url: 'mat/search/product',
        notApi: true,
        data: {
            location,
            manufacturer,
            model,
            type,
        },
        force: true,
    });

export default productRequest;
